import { pxToRem } from '../../../../utils';
export var menuItemContentStyles = {
  root: function root(_ref) {
    var p = _ref.props;
    var widthAdjust = (p.hasIcon ? 26 : 0) + (p.hasMenu ? 16 : 0);
    return Object.assign({
      whiteSpace: 'normal',
      lineHeight: 1.5,
      marginTop: pxToRem(-4),
      marginBottom: pxToRem(-4),
      display: 'inline-block'
    }, (p.inSubmenu || p.vertical) && {
      width: 'max-content',
      minWidth: pxToRem(46 - widthAdjust),
      maxWidth: pxToRem(262 - widthAdjust),
      marginRight: pxToRem(16)
    });
  }
};
//# sourceMappingURL=menuItemContentStyles.js.map
